<template>
  <v-snackbar v-model="show" color="green" timeout="10000" multi-line bottom>
    Syncing Data
    <template v-slot:action="">
      <v-progress-circular indeterminate></v-progress-circular>
    </template>
  </v-snackbar>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'DataSyncNotification',
  data() {
    return {
      show: false,
    };
  },
  computed: {
    ...mapState(['dataSyncStore']),
    dataSyncing() {
      return this.dataSyncStore ? this.dataSyncStore.dataSyncing : false;
    },
  },
  watch: {
    dataSyncing(newValue) {
      if (newValue === true) {
        this.show = true;
      } else {
        setTimeout(() => {
          this.show = false;
        }, 2000);
      }
    },
  },
};
</script>
